/**
 * Serializa un objeto Date a un string ISO 8601 usando el offset de la propia fecha,
 * evitando la ambigüedad DST que produce mezclar getHours() (TZ actual del navegador)
 * con el offset de una referencia externa.
 *
 * El offset se obtiene de date.getTimezoneOffset(), de modo que:
 * - Una fecha de invierno produce "+01:00" (España UTC+1)
 * - Una fecha de verano produce "+02:00" (España UTC+2)
 * - Si el usuario mueve un registro de invierno a una fecha de verano, el offset
 *   cambia automáticamente al correcto para esa nueva fecha.
 *
 * @param {Date} date - La fecha a serializar. Su timestamp UTC es invariante.
 * @returns {string} - String ISO 8601, p.ej. "2026-03-27T13:58:28+01:00"
 *
 * @example
 * // Fecha de invierno → +01:00
 * formatDate(new Date('2026-01-10T11:00:00Z'))  // "2026-01-10T12:00:00+01:00"
 *
 * // Fecha de verano → +02:00
 * formatDate(new Date('2026-07-10T10:00:00Z'))  // "2026-07-10T12:00:00+02:00"
 */
export function formatDate(date) {
  const offsetMinutes = date.getTimezoneOffset()
  const sign = offsetMinutes > 0 ? '-' : '+'
  const absOffset = Math.abs(offsetMinutes)
  const oh = String(Math.floor(absOffset / 60)).padStart(2, '0')
  const om = String(absOffset % 60).padStart(2, '0')

  // Desplazar el timestamp UTC en la cantidad del offset para obtener
  // las componentes horarias "locales" sin depender de la TZ del navegador.
  const localMs = date.getTime() + (-offsetMinutes) * 60 * 1000
  const local = new Date(localMs)

  const year  = local.getUTCFullYear()
  const month = String(local.getUTCMonth() + 1).padStart(2, '0')
  const day   = String(local.getUTCDate()).padStart(2, '0')
  const h     = String(local.getUTCHours()).padStart(2, '0')
  const m     = String(local.getUTCMinutes()).padStart(2, '0')
  const s     = String(local.getUTCSeconds()).padStart(2, '0')

  return `${year}-${month}-${day}T${h}:${m}:${s}${sign}${oh}:${om}`
}
